import api from './api'

// Get all timesheets with pagination and filters
export const getAllTimesheets = async (params = {}) => {
  try {
    const response = await api.get('/timesheets', { params })
    return response.data
  } catch (error) {
    console.error('Error fetching timesheets:', error)
    throw error
  }
}

// Get timesheet by ID
export const getTimesheetById = async (id) => {
  try {
    const response = await api.get(`/timesheets/${id}`)
    return response.data
  } catch (error) {
    console.error('Error fetching timesheet:', error)
    throw error
  }
}

// Create new timesheet
export const createTimesheet = async (timesheetData) => {
  try {
    const response = await api.post('/timesheets', timesheetData)
    return response.data
  } catch (error) {
    console.error('Error creating timesheet:', error)
    throw error
  }
}

// Update timesheet
export const updateTimesheet = async (id, timesheetData) => {
  try {
    const response = await api.put(`/timesheets/${id}`, timesheetData)
    return response.data
  } catch (error) {
    console.error('Error updating timesheet:', error)
    throw error
  }
}

// Delete timesheet
export const deleteTimesheet = async (id) => {
  try {
    const response = await api.delete(`/timesheets/${id}`)
    return response.data
  } catch (error) {
    console.error('Error deleting timesheet:', error)
    throw error
  }
}

// Get timesheet statistics
export const getTimesheetStats = async (params = {}) => {
  try {
    const response = await api.get('/timesheets/stats', { params })
    return response.data
  } catch (error) {
    console.error('Error fetching timesheet stats:', error)
    throw error
  }
}

const timesheetService = {
  getAllTimesheets,
  getTimesheetById,
  createTimesheet,
  updateTimesheet,
  deleteTimesheet,
  getTimesheetStats
}

export default timesheetService

